import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initializeAuth } from './services/auth-storage'

// Initialize auth token before mounting the app
initializeAuth();
console.log('App initialization complete - Ready to render');

createRoot(document.getElementById("root")!).render(<App />)
